<template>
  <div class="directoryes">
    <div class="information_header">
      <h1>Справочник лабораторных исследований</h1>
    </div>
    <div class="directoryes_headline">
      <div class="directoryes_left">
        <button  @click="addGroup" class="mb-2 btn">+ Добавить группу</button>
      </div>
      <div class="directoryes_right">
        <div class="directoryes_search">
          <label for="search_name">Поиск по названию</label>
          <input
            id="search_name"
            v-model="search"
            class="directoryes_search-input"
          />
          <svg class="svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
          </svg>
        </div>
      </div>
    </div>
      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="list"
          :loading="loadingTable"
          loading-text="Данные загружаются..."
          :page="page"
          sort-by="Name"
          :items-per-page="itemsPerPage"
          :search="search"
          hide-default-footer
      >
      <template v-slot:[`header.name`]="{ header }">
            <span style="font-size: 14px">{{ header.text}}</span>
        </template>
        <template v-slot:item="{ item, index }">
                <tr @mouseover="changeIndex(index)" @mouseleave="indexHover = false">
                    <th>
                        <v-row align="center">
                            <v-col md="auto">
                                <img class="cursor-pointer" v-if="item.properties.length > 0 && !item.openList" @click="item.openList = !item.openList" svg-inline :src="require('@/assets/img/icons/ArrowRight.svg')" />
                                <img class="cursor-pointer" v-if="item.openList" svg-inline @click="item.openList = !item.openList" :src="require('@/assets/img/icons/ArrowDown.svg')" />
                            </v-col>
                            <v-col md="auto">
                                <span style="font-size: 14px">{{ item.name}}</span>
                            </v-col>
                        </v-row>
                    </th>
                    <th>
                        <div v-if="indexHover === index" class="d-flex justify-end align-center border-b-none">
                            <v-btn class="btn-icon" color="#4854FE" :disabled="item.moveDownDisabled || moveGroupDownDisabled(index)" @click="updateGroupOrder(item.id, false, index, index + 1)">
                                <v-icon color="#fff" title="Переместить вниз" alt="Переместить вниз" >mdi-arrow-down</v-icon>
                            </v-btn>
                            <v-btn class="btn-icon" color="#4854FE" :disabled="item.moveUpDisabled || moveGroupUpDisabled(index)" @click="updateGroupOrder(item.id, true, index, index - 1)">
                                <v-icon color="#fff" title="Переместить вверх" alt="Переместить вверх">mdi-arrow-up</v-icon>
                            </v-btn>
                            <button style="width: 200px;" small @click="addProperty(item)" class="btn d-flex justify-center">+ Добавить показатель</button>
                            <button small @click="editGroup(item)" class="ml-2 btn">Редактировать</button>
                            <button small @click="deleteGroup(item)" class="ml-2 btn-add" outlined color="indigo">Удалить</button>
                        </div>

                    </th>
                </tr>
                <tr @mouseover="changeIndexPro(key)" @mouseleave="indexHoverPro = false" class="gray-bg" v-show="item.openList" v-for="(it, key) in item.properties" :key="'AB'+it.id+key">
                    <td>{{ it.name }}</td>
                    <td>
                        <div v-if="indexHoverPro === key" class="d-flex justify-end align-center border-b-none">
                            <v-btn class="btn-icon" color="#4854FE" :disabled="key === item.properties.length - 1" @click="updatePropertyOrder(it.id, false, index, key, key + 1)">
                                <v-icon color="#fff" title="Переместить вниз" alt="Переместить вниз">mdi-arrow-down</v-icon>
                            </v-btn>
                            <v-btn class="btn-icon" color="#4854FE" :disabled="key === 0" @click="updatePropertyOrder(it.id, true, index, key, key - 1)">
                                <v-icon color="#fff" title="Переместить вверх" alt="Переместить вверх">mdi-arrow-up</v-icon>
                            </v-btn>
                            <button small @click="editeProperty(it)" class="btn">Редактировать</button>
                            <button small @click="deleteProperty(index, it, key)" class="ml-2 btn-add" outlined color="indigo">Удалить</button>
                        </div>
                    </td>
                </tr>
            </template>
      <template v-slot:footer="{ props }">
              <div class="data-footer">
                  <div class="items-per-page">
                      <span>Строк на странице:</span>

                      <div class="items-per-page_item" :class="{active: itemsPerPage == 5}" @click.prevent="itemsPerPage = 5">
                          5
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == 10}" @click.prevent="itemsPerPage = 10">
                          10
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == 15}" @click.prevent="itemsPerPage = 15">
                          15
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == -1}" @click.prevent="itemsPerPage = -1">
                          все
                      </div>
                  </div>
                  <div class="pagination" v-if="itemsPerPage != -1">
                      <div class="pagination_prev" @click.prevent="page == 1 ? page : --page">
                          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
                          </svg>
                      </div>
                      <div class="pagination_number">
                          {{ props.pagination.pageStart + 1 }} - {{ props.pagination.pageStop }} из {{props.pagination.itemsLength}}
                      </div>
                      <div class="pagination_next" v-if="itemsPerPage" @click.prevent="page == props.pagination.pageCount ? page : ++page">
                          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
                          </svg>
                      </div>
                  </div>
              </div>
          </template>

          <v-progress-linear :active="loadingTable" :indeterminate="loadingTable" absolute bottom color="primary accent-4" ></v-progress-linear>
      </v-data-table>

       <!-- Добавление группы -->
       <v-dialog v-model="dialogGroup" max-width="800px" persistent>
        <div class="d-flex justify-end">
            <v-btn class="close" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </v-btn>
        </div>
            <v-card max-width="770px">
                <div style="width: 700px; padding: 20px 0 0 30px;" class="d-flex justify-space-between">
                    <h2 class="header" >{{titleDialog}} группы лабороторных исследований</h2>
                  </div>
                <v-card-text class="pb-0">
                    <v-container>
                        <v-form v-model="valid" ref="form" lazy-validation>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <h3 class="title-font">Наименование группы</h3>
                                    <v-text-field class="title-font" color="#4854FE" :rules="[rules.required, snackbar ? rules.req : true  ]" dense outlined v-model="group.name"/>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions class="pb-5 d-flex justify-end">
                  <button class="btn" @click="saveGroup(group)">Сохранить</button>
              </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Добавление значения -->
      <v-dialog v-model="dialogProperty" max-width="1100px" persistent>
        <div class="d-flex justify-end">
            <v-btn class="close" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </v-btn>
        </div>
          <v-card max-width="1070px">
                  <div style="width: 950px; padding: 20px 0 0 30px;" class="d-flex justify-space-between">
                    <h2 class="header" >{{titleDialog}} показателя лабороторных исследований</h2>
                  </div>

              <v-card-text class="pb-0">
                  <v-container>
                      <v-form v-model="validProperty" ref="formProperty" lazy-validation>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-row class="d-flex flex-nowrap">
                                    <v-col class="mr-6" cols="12" sm="12" md="4">
                                        <h3 class="title-font">Наименование</h3>
                                        <v-text-field class="title-font" color="#4854FE" :rules="[rules.required, snackbar ? rules.req : true ]" dense hide-details outlined v-model="property.name" />
                                    </v-col>
                                    <v-col class="mr-6" cols="12" sm="12" md="4">
                                        <h3 class="title-font">Наименование группы</h3>
                                        <v-select class="title-font" color="#4854FE" readonly :rules="[rules.required]" :items="list" item-text="name" item-value="id" dense hide-details outlined v-model="property.groupId" />
                                    </v-col>
                                    <v-col class="ml-6" cols="12" sm="12" md="3">
                                        <h3 class="mb-2">Пол</h3>
                                        <v-radio-group v-model="property.sex" hide-details dense row>
                                            <v-radio color="#4854FE" label="М" :value="0"></v-radio>
                                            <v-radio color="#4854FE" label="Ж" :value="1"></v-radio>
                                            <v-radio color="#4854FE" label="МЖ" :value="2"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    </v-row>
                                </v-col>


                                <v-col cols="12" sm="12" md="12">
                                    <v-btn outlined class="mb-2" @click="addRow(property.ageValues)">
										+ Добавить возраст
                                    </v-btn>
                                    <v-card v-for="(item, key) in property.ageValues" :key="'A'+key" class="mt-2">
                                        <v-card-text>
                                            <v-row class="d-flex flex-nowrap" >
										<v-col cols="2" sm="2" md="2" align-self="start">
                                            <h3 class="title-font mb-6">Возраст</h3>
                                            <v-text-field class="title-font" color="#4854FE" v-if="item.typeAgeOnDay === 1" type="number" :rules="[rules.required, item.age.day ? rules.negativeNum(item.age.day) : true, item.age.day ? rules.minMax(item.age.day, 1, 29) : true]" outlined dense hide-details v-model="item.age.day" label="" placeholder="От 1 до 29" />
                                            <v-row v-if="item.typeAgeOnDay === 2">
                                                <v-col cols="6" sm="6" md="6">
                                                    <v-text-field class="title-font" color="#4854FE" type="number" :rules="[rules.required, item.age.monthAndDay.month ? rules.negativeNum(item.age.monthAndDay.month) : true, item.age.monthAndDay.month ? rules.minMax(item.age.monthAndDay.month, 1, 11) : true]" outlined dense hide-details v-model="item.age.monthAndDay.month" label="Мес." placeholder="1-11" />
                                                </v-col>
                                                <v-col cols="6" sm="6" md="6">
                                                    <v-text-field class="title-font" color="#4854FE" type="number" :rules="[rules.required, item.age.monthAndDay.day ? rules.negativeNum(item.age.monthAndDay.day) : true, item.age.monthAndDay.day ? rules.minMax(item.age.monthAndDay.day, 1, 29) : true]" outlined dense hide-details v-model="item.age.monthAndDay.day" label="Дней" placeholder="1-29" />
                                                </v-col>
                                            </v-row>

                                            <v-row v-if="item.typeAgeOnDay === 3">
                                                <v-col cols="6" sm="6" md="6">
                                                    <v-text-field class="title-font" color="#4854FE" type="number" :rules="[rules.required, item.age.yearAndMonth.year ? rules.negativeNum(item.age.yearAndMonth.year) : true, item.age.yearAndMonth.year && item.age.yearAndMonth.year > 4 ? rules.minMax(item.age.yearAndMonth.year, 5, 120) : true]" @input="typingYear(item.age.yearAndMonth.year)" outlined dense hide-details v-model="item.age.yearAndMonth.year" label="Лет" />
                                                </v-col>
                                                <v-col cols="6" sm="6" md="6">
                                                    <v-text-field class="title-font" color="#4854FE" :disabled="+item.age.yearAndMonth.year >= 5" type="number" :rules="[+item.age.yearAndMonth.year < 5 ? rules.required : true, item.age.yearAndMonth.month ? rules.negativeNum(item.age.yearAndMonth.month) : true, item.age.yearAndMonth.month ? rules.minMax(item.age.yearAndMonth.month, 0, 11) : true]" outlined dense hide-details v-model="item.age.yearAndMonth.month" label="Мес." placeholder="1-11" />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col style=" margin-top: 42px; height: 24px;" cols="2" sm="2" md="2">
                                            <v-select class="title-font" color="#4854FE" item-text="name" @change="changeType(item)" item-value="id" :items="listAgeOnDay" v-model="item.typeAgeOnDay" outlined dense hide-details label="" />
                                        </v-col>

										<v-col cols="3" sm="3" md="auto" align-self="start">
                                            <h3 class="title-font ">Тип</h3>
											<v-radio-group :disabled="key > 0 " :readonly="property.ageValues.length > 1 " class="mt-5" dense hide-details v-model="item.valueType" row>
												<v-radio color="#4854FE" label="Диапазон" :value="0" />
												<v-radio color="#4854FE"  label="Значение" :value="1" />
											</v-radio-group>
										</v-col>
										<v-col cols="5" sm="5" md="5" align-self="end">

                                            <!-- Диапазон -->
											<v-row v-if="item.valueType == 0">
												<v-col cols="3" sm="3" md="3">
													<v-text-field class="title-font" color="#4854FE" type="number" :rules="[rules.required, item.valueFrom && item.valueTo ? rules.rangeFromTo(+item.valueFrom, +item.valueTo) : true, rules.negativeNum]" outlined dense hide-details v-model="item.valueFrom" label="От" />
												</v-col>
												<v-col cols="3" sm="3" md="3">
													<v-text-field class="title-font" color="#4854FE" type="number" :rules="[rules.required, item.valueFrom && item.valueTo ? rules.rangeFromTo(+item.valueFrom, +item.valueTo) : true, rules.negativeNum]" outlined dense hide-details v-model="item.valueTo" label="До" />
												</v-col>

                                                <v-col cols="4" :sm="key === 0 ? 5 : 4" :md="key === 0 ? 5 : 4" align-self="end">
													<v-autocomplete class="title-font" color="#4854FE" :rules="[rules.required]" outlined dense hide-details :items="listMeasurements" item-text="name" item-value="id" v-model="item.measurementId" label="Ед. Изм." />
												</v-col>
												<v-col v-if="key !== 0" cols="1" sm="1" md="1" class="m">
													<v-btn @click="deleteRow(property.ageValues, key)" small color="primary" icon class="mt-1">
														<img svg-inline :src="require('@/assets/img/icons/Trash.svg')" />
                                                    </v-btn>
												</v-col>
											</v-row>

											<!-- Значение -->
											<v-row v-if="item.valueType == 1">
												<v-col :cols="key === 0 ? 11 : 10" :sm="key === 0 ? 11 : 10" :md="key === 0 ? 11 : 10">
													<!-- {{ property.listValues }} -->
                                                    <reference-field
                                                        class="title-font"
                                                        color="#4854FE"
                                                        v-model="item.listValueIds"
                                                        label=""
                                                        :items="property.listValues"
                                                        item-text="name"
                                                        :rules="[rules.requiredMultiple]"
                                                        item-value="id"
                                                        :multiple="true"
                                                        :clearable="true"
                                                        v-on:saveParams="saveParams($event, property)"
                                                        v-on:snackBar="snackBarFunc"
                                                    />
												</v-col>
												<v-col v-if="key !== 0" cols="1" sm="1" md="1" class="m">
													<v-btn @click="deleteRow(property.ageValues, key)" small color="error" icon>
														<img svg-inline :src="require('@/assets/img/icons/Trash.svg')" />
                                                    </v-btn>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                      </v-form>
                  </v-container>
              </v-card-text>

              <v-card-actions class="pb-5 mr-4 d-flex justify-end">
                <button class="ma-2 btn-add" outlined color="indigo" @click="close">Отменить</button>
                  <button class="btn"  @click="saveProperty(property)">Сохранить</button>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <v-snackbar rounded="pill" elevation="24" :color="snackbarColor" top v-model="snackbar">
          <div class="d-flex align-center">
              <img svg-inline :src="require('@/assets/img/icons/Information.svg')" />
              <span class="ml-4">{{ snackbar_text }}</span>
          </div>
      </v-snackbar>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import "../directory.scss"
import referenceField from '@/components/ReferenceField/index.vue'
import { convertingYearsAndMonthsToDays, convertingDaysToYearsAndMonths } from '@/others/transformation'
export default {
  name: 'SprLabResearch',
  computed: {
      ...mapGetters({
          apiGuide: 'apiGuide',
          apiUrl:'apiUrl'
      })
  },
  components: { referenceField },

  data: () => ({
        loadImport: false,
        listAgeOnDay: [
            { id: 1, name: 'Дней' },
            { id: 2, name: 'Месяцев и дней' },
            { id: 3, name: 'Лет и месяцев' }
        ],
        loadingListMeasurements: false,
        selectedGroupId: null,
        edite: false,
        editeLoading: false,
        valid: false,
        indexHoverPro: false,
        overlay: false,
        validProperty: false,
        timeout: 2000,
        indexHover: false,
        snackbar: false,
        snackbar_text: '',
        snackbarColor: '',
        titleDialog: '',
        loadingTable: false,
        dialogGroup: false,
        dialogProperty: false,
        dialogImport: false,
        guideFile: null,
        sendingRequest: false,
        list: [],
        listMeasurements: [],
        listAnalyzers: [],
        group: {
            name: ''
        },
        property: {
            name: '',
            groupId: '',
            sex: 2,
            listValues: [],
            ageValues: [
                {
                    age: {
                        day: null,
                        yearAndMonth: { year: null, month: null},
                        monthAndDay: { month: null, day: null }
                    },
                    typeAgeOnDay: 1,
                    valueType: 0,
                    valueFrom: null,
                    valueTo: null,
                    valueText: '',
                    listValueIds: [],
                    measurementId: null,
                    analyzerId: null
                }
            ]
        },
        headers: [
            { text: 'Наименование', value: 'name' },
            { text: '', value: 'actions', sortable: false, width: 215 }
        ],
        pagination: {
            sortBy: 'name'
        },
        page: 1,
        itemsPerPage: 10,
        search: '',
        rules: {
            required: (v, text) => (!!v || v === 0) || (text ? text : 'Обязательно для заполнения.'),
            requiredMultiple: (v) => v.length > 0 || 'Обязательно для заполнения.',
            minMax: (v, min, max) => v >= min && v <= max || 'Референс не соблюден!.',
            rangeFromTo: (a, b) => {
				if(a > b) return false;
				if(a < b) return true;
				if(a === b) return true;
				return false
			},
            negativeNum: (v) => (Math.sign(+v) === 1 || Math.sign(+v)===0) || 'Возраст не может быть отрицательным',
            isCeil: (v) => (String(v).split('.').length === 1 && String(v).split(',').length === 1) || 'Число должно быть целым.'
        }
    }),
    methods:{
        addGroup() {
            this.titleDialog = 'Добавление'
            this.dialogGroup = true
        },
        changeIndex(index){
        this.indexHover = index
      },
      changeIndexPro(index){
        this.indexHoverPro = index;
      },
        moveGroupDownDisabled(index) {
            let lastPage = 1;
            let lastIndex = this.list.length - 1;

            if (this.itemsPerPage !== -1) {
                lastPage = Math.floor(this.list.length / this.itemsPerPage) + 1;
                lastIndex = this.list.length % this.itemsPerPage - 1;
            }

            return this.page === lastPage && index === lastIndex;
        },
        moveGroupUpDisabled(index) {
            return this.page === 1 && index === 0;
        },
        updateGroupOrder(id, up, indexFrom, indexTo) {
            this.$http.put(`${this.apiGuide}api/SprLabResearch/UpdateGroupOrder?id=${id}&up=${up}`)
                .then((res) => {
                    indexFrom = indexFrom + (this.page - 1) * this.itemsPerPage;
                    indexTo = indexTo + (this.page - 1) * this.itemsPerPage;
                    this.list[indexFrom] = this.list.splice(indexTo, 1, this.list[indexFrom])[0];
                })
                .catch((err) => {
                    if(err) {
                        this.snackBarFunc(true, 'Запись с таким именем уже существует!!!', 'error')
                    }
                })
        },
        editGroup(item) {
            this.edite = true;
            this.titleDialog = 'Редактирование'
            this.group = Object.assign({}, item);
            this.dialogGroup = true
        },
        deleteGroup(item){
            if(item.properties.length > 0) {
                this.snackBarFunc(true, 'Удаление невозможно, в группе есть показатели!!!', 'warning')
                return;
            }
            if(confirm('Вы уверены, что хотите удалить группу?')) {
                this.$http.delete(`${this.apiGuide}api/SprLabResearch/MarkGroupAsDelete?id=${item.id}`, {})
                .then(() => {
                    let index = this.list.findIndex((f) => f.id === item.id);
                    this.list.splice(index, 1);
                });
            }
        },
        saveGroup(item) {
            if(this.$refs.form.validate()) {
                this.saveLoading = true;
                if(this.edite) {
                    this.$http.put(`${this.apiGuide}api/SprLabResearch/UpdateGroup`, {
                        id: item.id,
                        name: item.name
                    })
                    .then((res) => {
                        for (let i = 0; i < this.list.length; i++) {
                            if(this.list[i].id === res.data.id) {
                                this.list[i].name = res.data.name;
                            }
                        }
                        this.close();
                    })
                    .catch((err) => {
                        if(err) {
                            this.snackBarFunc(true, 'Запись с таким именем уже существует!!!', 'error')
                        }
                    })
                } else {
                    this.$http.post(`${this.apiGuide}api/SprLabResearch/AddGroup`, {
                        name: item.name
                    })
                    .then((res) => {
                        this.$set(res.data, 'openList', false)
                        this.list.unshift(res.data);
                        this.close();
                    })
                    .catch((err) => {
                        if(err) {
                            this.snackBarFunc(true, 'Запись с таким именем уже существует!!!', 'error')
                        }
                    })
                }
            } else {
                this.snackBarFunc(true, 'Заполните обязательные поля!!!', 'warning')
            }
        },
        addProperty(item) {
            this.titleDialog = 'Добавление';
            this.property.groupId = item.id;
            this.selectedGroupId = item.id;
            this.dialogProperty = true;
        },
        updatePropertyOrder(id, up, indexGroup, indexFrom, indexTo) {
            this.$http.put(`${this.apiGuide}api/SprLabResearch/UpdatePropertyOrder?id=${id}&up=${up}`)
                .then((res) => {
                    this.list[indexGroup].properties[indexFrom] = this.list[indexGroup].properties.splice(indexTo, 1, this.list[indexGroup].properties[indexFrom])[0];
                })
                .catch((err) => {
                    if(err) {
                        this.snackBarFunc(true, 'Запись с таким именем уже существует!!!', 'error')
                    }
                })
        },
        editeProperty(item) {
            this.editeLoading = true;
            this.$http.get(`${this.apiGuide}api/SprLabResearch/GetPropertyById?propertyId=${item.id}`)
            .then((res) => {
                this.edite = true;
                this.titleDialog = 'Редактирование'
                this.property = Object.assign({}, convertingDaysToYearsAndMonths(res.data));
                this.dialogProperty = true
                this.editeLoading = false;
            })
        },
        deleteProperty(indexGroup, it, indexProperty) {
            if(confirm('Вы уверены, что хотите удалить показатель?')) {
                this.$http.delete(`${this.apiGuide}api/SprLabResearch/MarkPropertyAsDelete?id=${it.id}`, {})
                .then(() => {
                    if(this.search.length > 0) {
                        let resFilter = this.list.filter( (f) => f.name.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) !== -1 );

                        resFilter[indexGroup].properties.splice(indexProperty, 1);
                        return;
                    }

                    this.list[indexGroup].properties.splice(indexProperty, 1);
                });
            }
        },
        saveProperty(property) {
            if(this.$refs.formProperty.validate()) {
                for (let i = 0; i < property.ageValues.length; i++) {
                    property.ageValues[i] = {
                        id: this.edite ? property.ageValues[i].id : undefined,
                        ageOnDay: convertingYearsAndMonthsToDays(property.ageValues[i].age),
                        valueTo: property.ageValues[i].valueTo,
                        valueFrom: property.ageValues[i].valueFrom,
                        valueText: property.ageValues[i].valueText,
                        valueType: property.ageValues[i].valueType,
                        measurementId: property.ageValues[i].measurementId,
                        analyzerId: property.ageValues[i].analyzerId,
                        listValueIds: property.ageValues[i].listValueIds,
                        age: property.ageValues[i].age,
                        typeAgeOnDay: property.ageValues[i].typeAgeOnDay
                    }
                }

                this.saveLoading = true;
                if(this.edite) {
                    this.$http.put(`${this.apiGuide}api/SprLabResearch/UpdateProperty`, property)
                    .then((res) => {
                        for (let i = 0; i < this.list.length; i++) {
                            if(this.list[i].id === res.data.groupId) {
                                for (let k = 0; k < this.list[i].properties.length; k++) {
                                    if(this.list[i].properties[k].id === res.data.id) {
                                        Object.assign(this.list[i].properties[k], res.data);
                                    }
                                }
                            }
                        }
                        this.close();
                    })
                    .catch((err) => {
                        if(err) {
                            this.snackBarFunc(true, 'Запись с таким именем уже существует!!!', 'error')
                        }
                    })
                } else {
                    this.$http.post(`${this.apiGuide}api/SprLabResearch/AddProperty`, property)
                    .then((res) => {
                        for (let i = 0; i < this.list.length; i++) {
                            if(this.list[i].id == res.data.groupId) {
                                this.list[i].properties.unshift(res.data)
                            }
                        }
                        this.close();
                    })
                    .catch((err) => {
                        if(err) {
                            this.snackBarFunc(true, 'Запись с таким именем уже существует!!!', 'error')
                        }
                    })
                }
            } else {
                this.snackBarFunc(true, 'Заполните обязательные поля!!!', 'warning')
            }
        },
        addRow(array) {
            array.splice(1, 0, {
				age: {
                    day: null,
                    yearAndMonth: { year: null, month: null},
                    monthAndDay: { month: null, day: null }
                },
                typeAgeOnDay: 1,
				valueType: array[0] ? array[0].valueType : 0,
                valueFrom: null,
                valueTo: null,
                valueText: '',
                listValueIds: [],
                measurementId: array.length === 0 ? null : array[0].measurementId,
                analyzerId: array.length === 0 ? null : array[0].analyzerId
			})
		},
        deleteRow(array, index) {
            if (array[index].hasSymptom) {
                alert('Значение привязано к симптому и не может быть удалено.');
                return;
            }

			if(confirm('Вы уверены что хотите удалить ?')) {
				array.splice(index, 1)
			}
		},
        snackBarFunc(flag, text, color) {
			this.snackbar = flag
			this.snackbar_text = text
			this.snackbarColor = color
		},
        close() {
            if(this.$refs.formProperty) this.$refs.formProperty.resetValidation();
            if(this.$refs.form) this.$refs.form.resetValidation();
            this.dialogImport = false;
            this.guideFile = null;
            this.edite = false;
            this.group.name = '';
            this.property = {
                name: '',
                groupId: '',
                sex: 2,
                listValues: [],
                ageValues: [
                    {
                        age: {
                            day: null,
                            yearAndMonth: { year: null, month: null},
                            monthAndDay: { month: null, day: null }
                        },
                        typeAgeOnDay: 1,
                        valueType: 0,
                        valueFrom: null,
                        valueTo: null,
                        valueText: '',
                        listValueIds: [],
                        measurementId: null,
                        analyzerId: null
                    }
                ]
            }
            this.dialogGroup = false;
            this.dialogProperty = false;
        },
        selectMeasurement(id){
            this.loadingListMeasurements = true;

            this.$http.get(`${this.apiGuide}api/SprAnalyzerMeasurement/GetByAnalyzerId?id=${id}`)
            .then((res) => {
                this.listMeasurements = this.sortArray(res.data.measurements, 'name');
                this.loadingListMeasurements = false;
            })
        },
        sortArray(array, name){
            return array.sort((prev, next) => {
                const nameA = typeof prev[name] === 'string' ? prev[name].toUpperCase() : prev[name];
                const nameB = typeof next[name] === 'string' ? next[name].toUpperCase() : next[name];

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            })
        },
        get(){
            this.$http.get(`${this.apiGuide}api/SprLabResearch/GetAllGroups`)
            .then((res) => {
                for (let i = 0; i < res.data.length; i++) {
                    this.$set(res.data[i], 'openList', false)
                }

                this.list = this.sortArray(res.data, 'sortOrder');

                this.list.forEach(x => {
                    x.properties = this.sortArray(x.properties, 'sortOrder');
                });

                this.loadingTable = false;
            })
        },

        S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        },
        guidGener() {
            return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4())
        },
        saveParams(event, property) {
            if(this.edite) {
                this.$http.post(`${this.apiGuide}api/SprLabResearch/AddListValue`, {
                    name: event,
                    propertyId: property.id
                })
                .then((res) => {
                    if(res.status === 200) {
                        property.listValues.unshift(res.data);
                    } else {
                        this.snackBarFunc(true, 'Ошибка сохранения значения в справочник, обратитесь к администратору!', 'error');
                    }
                })
                .catch((err) => {
                    if(err) {
                        this.snackBarFunc(true, 'Ошибка сохранения значения в справочник, обратитесь к администратору!', 'error');
                    }
                })
            } else {
                property.listValues.unshift({id: this.guidGener(), name: event});
            }
        },
        changeType(item) {
            item.age = {
                day: null,
                yearAndMonth: { year: null, month: null},
                monthAndDay: { month: null, day: null }
            };
        },
        typingYear(age) {
            if(+age.year > 4) {
                age.month = null;
            }
        },
    },
    created(){
            this.get();

            this.$http.get(`${this.apiGuide}api/SprMeasurement/GetAll`)
                .then((res) => {
                    this.listMeasurements = this.sortArray(res.data, 'name');
                })

            this.$http.get(`${this.apiGuide}api/SprAnalyzer/GetAll`)
                .then((res) => {
                    this.listAnalyzers = this.sortArray(res.data, 'name');
                })
    }
}
</script>
<style scoped>
.btn {
        padding: 6px 12px;
        border-radius: 8px;
        background: #4854FE;
        color: #FFF;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
  }
  .svg {
      position: absolute;
      top: 30px;
      right: 10px;
    }
    .btn-add {
        padding: 6px 12px;
        border-radius: 8px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        border: 2px solid #4854FE;
        color: #4854FE !important;
}
.v-btn{
        padding: 6px 12px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        color: #4854FE !important;
        text-transform: initial;
}
.btn-icon{
    min-width: 40px!important;
    border-radius: 8px;
    margin-right: 5px;
    padding: 0!important;
}
.m{
    margin-left: -10px;
}
</style>
